import styled from 'styled-components';

export const MessageStyled = styled.div`
  padding: 40px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  border: 1px solid #dddddd;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 465px;
  background: #ffffff;
  .closeImg {
    position: absolute;
    right: 10px;
    top: 10px;
    cursor: pointer;
  }

  button {
    width: calc((100% - 24px) / 2);
  }
`;
